import {useContext} from "react";
import {Button as GlobalButton} from "../../../components/custom-components/Button";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import PropTypes from "prop-types";

function Button(props: any) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    const scheme = props.scheme ?? "solid";
    const padding = props.paddingType ?? "normal";
    return <GlobalButton
        {...props}
        pressedStyle={{
            backgroundColor: colors.get("transparentBackground")
        }}
        textStyle={{
            color: scheme == "solid" ? "#fff" : props.color ?? colors.get("primaryColor"),
            alignSelf: "center",
            fontFamily: "IRANsans_medium",
            fontSize: 14
        }}
        style={[{
            borderRadius: 15,
            paddingVertical: padding == "narrow" ? 6 : 12,
            paddingHorizontal: padding == "narrow" ? 12 : 19,
            backgroundColor: scheme == "solid" ? props.color ?? colors.get("primaryColor") : "#0000"
        }, props.style]}/>
}

Button.propTypes = {
    onPress: PropTypes.any,
    title: PropTypes.string,
    color: PropTypes.string,
    role: PropTypes.string,
    disabled: PropTypes.bool,
    style: PropTypes.any,
    paddingType: PropTypes.oneOf(["normal", "narrow"]),
    scheme: PropTypes.oneOf(["solid", "regular"])
}
export default Button;